import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Aprovar em lote", -1)
const _hoisted_2 = { class: "flex flex-col gap-3 text-left" }
const _hoisted_3 = {
  class: "text-sm text-textPrimary",
  "data-testid": "bulk-approve-count"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-neutral50" }, " A aprovação alimenta o pagamento e não pode ser desfeita em lote — cada registro precisaria ser revertido individualmente. ", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-alert",
  "data-testid": "bulk-approve-capped"
}
const _hoisted_6 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { computed } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { BULK_APPROVE_MAX_CONTAINERS } from '@/constants/ds-attendance.constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceBulkApproveModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean },
    count: {},
    cappedOut: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * Apontamento 4 — a ÚNICA ação desta tela com confirmação extra, porque é a única que
 * aprova vários registros de uma vez e alimenta pagamento. A confirmação mostra a contagem
 * exata para o operador conferir antes de disparar.
 */




const maxPerBatch = BULK_APPROVE_MAX_CONTAINERS

const countMessage = computed(() =>
  props.count === 1
    ? '1 registro 100% conciliado será aprovado.'
    : `${props.count} registros 100% conciliados serão aprovados.`
)

const cappedOut = computed(() => props.cappedOut ?? 0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[560px]",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "bulk-approve-cancel-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }),
        _createVNode(FilledButton, {
          text: `Aprovar ${_ctx.count} ${_ctx.count === 1 ? 'registro' : 'registros'}`,
          class: "bg-primary30",
          width: "200px",
          height: "40px",
          disabled: _ctx.saving || _ctx.count === 0,
          "data-testid": "bulk-approve-confirm-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
        }, null, 8, ["text", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(countMessage.value), 1),
        _hoisted_4,
        (cappedOut.value > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " O lote é limitado a " + _toDisplayString(_unref(maxPerBatch)) + " registros por vez: " + _toDisplayString(cappedOut.value) + " " + _toDisplayString(cappedOut.value === 1 ? 'registro elegível ficará' : 'registros elegíveis ficarão') + " para um próximo lote. ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})